import React from "react";

import { Helmet as ReactHelmet } from "react-helmet";

const Helmet = ({ title }) => {
  return (
    <ReactHelmet>
      <title>{title}</title>
    </ReactHelmet>
  );
};

export default Helmet;
